export default function toggleArray(arr: unknown[], value: unknown): { resultArray: unknown[]; wasAdded: boolean } {
  const resultArray: unknown[] = arr.includes(value) ? arr.filter((item) => item !== value) : [...arr, value];

  const wasAdded = resultArray.length > arr.length;

  return { resultArray, wasAdded };
}
